import React from "react";

export const RESPONSE_TYPE = {
  TEXT: "text",
  IMAGE: "image",
};

const OPTIONS = [
  { value: RESPONSE_TYPE.TEXT, label: "💬 Texto" },
  { value: RESPONSE_TYPE.IMAGE, label: "🖼️ Imagen / Archivo" },
];

export const ActionTypeToggle = ({ value, onChange }) => (
  <div
    style={{
      display: "inline-flex",
      borderRadius: 10,
      border: "1px solid #e5e7eb",
      overflow: "hidden",
      backgroundColor: "#f9fafb",
    }}
  >
    {OPTIONS.map((opt, i) => {
      const active = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          style={{
            padding: "0.45rem 1rem",
            fontSize: "0.82rem",
            fontWeight: active ? 600 : 400,
            fontFamily: "Inter, sans-serif",
            border: "none",
            borderRight: i < OPTIONS.length - 1 ? "1px solid #e5e7eb" : "none",
            cursor: "pointer",
            transition: "all 0.18s",
            backgroundColor: active ? "#2c5f4e" : "transparent",
            color: active ? "#fff" : "#6b7280",
          }}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);
